import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import AuthContext from "../contexts/AuthContext";
import PageContext from "../contexts/PageContext";
import AppPagesEnum from "./appPagesEnum";
import LoadingScreen from "../components/LoadingScreen/LoadingScreen";
import Navigation from "../components/common/Navigation/Navigation";
import ToastContainer from "../components/common/ToastContainer/ToastContainer";
import LoginPage from "./Login/LoginPage";
import DashboardPage from "./Dashboard/DashboardPage";
import ApiKeyPage from "./ApiKey/ApiKeyPage";
import CredentialsPage from "./Credentials/CredentialsPage";
import AdminPage from "./Admin/AdminPage";
import "./app.less";
function PageRouter() {
    const { activePage } = useContext(PageContext);
    switch (activePage) {
        case AppPagesEnum.API_KEY:
            return _jsx(ApiKeyPage, {});
        case AppPagesEnum.SLACK:
            return _jsx(CredentialsPage, {});
        case AppPagesEnum.ADMIN:
            return _jsx(AdminPage, {});
        case AppPagesEnum.DASHBOARD:
        default:
            return _jsx(DashboardPage, {});
    }
}
export default function App() {
    const { isAuthenticated, isLoading } = useContext(AuthContext);
    if (isLoading) {
        return _jsx(LoadingScreen, { isLoading: true });
    }
    if (!isAuthenticated) {
        return _jsx(LoginPage, {});
    }
    return (_jsxs("div", { className: "HGU__layout", children: [_jsx(Navigation, {}), _jsx("main", { className: "HGU__main", children: _jsx(PageRouter, {}) }), _jsx(ToastContainer, {})] }));
}
